export class UserToCompany {
    public id: number | null;
    public user_id: number | null;
    public company_id: number | null;
    public access_type: number | null;
    public business_line_id: number | null;

    constructor(data: UserToCompanyData | void) {
        if (data === undefined) {
            this.id = null;
            this.user_id = null;
            this.company_id = null;
            this.access_type = null;
            this.business_line_id = null;
        } else {
            this.id = data.id;
            this.user_id = data.user_id;
            this.company_id = data.company_id;
            this.access_type = data.access_type;
            this.business_line_id = data.business_line_id;
        }
    }

    public resetToDefaults(): void {
        this.id = null;
        this.user_id = null;
        this.company_id = null;
        this.access_type = null;
        this.business_line_id = null;
    }
}

export type UserToCompanyData = {
    id: number | null;
    user_id: number | null;
    company_id: number | null;
    access_type: number | null;
    business_line_id: number | null;
}